module.exports = __webpack_public_path__ + "img/wx_code.7f210d16.png";